module.exports = __webpack_public_path__ + "static/media/taiji.f6edf897.jpg";